/*------------------------------------------------
// File Name:PDM_CONFIG_TEMPLATE.js
// File Description:PDM_CONFIG_TEMPLATE API方法js接口
// Author:zxl
// Create Time:2022/08/22 11:20:05
//------------------------------------------------*/
import { axios } from '@/utils/request'

const api = {
   _configTemplate: "/PDM_CONFIG_TEMPLATE"
}

export default api


//-------------------创建对象-------------------
export function CreatePDM_CONFIG_TEMPLATEEntity(parameter) {
    return axios({
        url: api._configTemplate + "/CreatePDM_CONFIG_TEMPLATEEntity",
        method: 'post',
        data: parameter
    })
}

//-------------------获取列表-------------------
export function GetPDM_CONFIG_TEMPLATEList(parameter) {
    return axios({
        url: api._configTemplate + "/GetPDM_CONFIG_TEMPLATEList",
        method: 'post',
        data: parameter
    })
}

//-------------------分页获取列表---------------
export function GetPDM_CONFIG_TEMPLATEListByPage(parameter) {
    return axios({
        url: api._configTemplate + "/GetPDM_CONFIG_TEMPLATEListByPage",
        method: 'post',
        data: parameter
    })
}

//-------------------获取对象---------------
export function GetPDM_CONFIG_TEMPLATEEntity(parameter) {
    return axios({
        url: api._configTemplate + "/GetPDM_CONFIG_TEMPLATEEntity",
        method: 'post',
        data: parameter
    })
}


//-------------------保存对象---------------
export function UpdatePDM_CONFIG_TEMPLATEEntity(parameter) {
    return axios({
        url: api._configTemplate+ "/UpdatePDM_CONFIG_TEMPLATEEntity",
        method: 'post',
        data: parameter
    })
}

//-------------------删掉对象---------------
export function DeletePDM_CONFIG_TEMPLATEEntity(parameter) {
    return axios({
        url: api._configTemplate + "/DeletePDM_CONFIG_TEMPLATEEntity",
        method: 'post',
        data: parameter
    })
}
